import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteHowToUseSaga,
  getHowToUseDetailsSaga,
  getHowToUseListSaga,
} from "src/store/web-howtouse/saga";
import { HowToUseDetailDto, HowToUseDto } from "src/store/web-howtouse/type";
import HowToUseCreateForm from "./create";
import HowToUseEditForm from "./edit";
const HowToUsePage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<HowToUseDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<HowToUseDetailDto>();
  const columns = [
    {
      text: t("HowToUse.Title"),
      dataField: "Title",
    },
    {
      text: t("HowToUse.Icon"),
      dataField: "Icon",
      formatter: (cellContent: string) => <i className={cellContent}></i>,
    },
    {
      text: t("HowToUse.ShowWeb"),
      dataField: "ShowWeb",
      formatter: (cellContent: boolean) =>
        cellContent ? (
          <i className="text-success bx  bx-check-square"></i>
        ) : (
          <i className="text-danger mdi mdi-close-box-outline"></i>
        ),
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("HowToUse.PageTitle")}
        metaTag={t("HowToUse.MetaTag")}
        gridProps={{
          addTitle: t("HowToUse.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getHowToUseListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getHowToUseDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: HowToUseDto) =>
              t("HowToUse.DeleteQA", {
                name: data.Title,
              }),
            action: deleteHowToUseSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <HowToUseCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getHowToUseListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <HowToUseEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getHowToUseListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default HowToUsePage;
